import {HEAVY_CART, HEAVY_BAG, HEAVY_PACKAGE} from "./Util";

const pounds = 2.20462;

export const getLastPackageReport = (reportName, metadata, uniqueCharSeq) => {

    if (metadata != null && metadata.wt != null && metadata.wt.value > 0) {
        return ` ${uniqueCharSeq}${reportName} Report ${uniqueCharSeq} 
    1. Weight of Last Package : ${metadata.wt.value.toFixed(2)} ${metadata.wt.unit} ( ${(metadata.wt.value * pounds).toFixed(2)} lb)
    2. Length of Last Package : ${metadata.length.value.toFixed(2)} ${metadata.length.unit}
    3. Width of Last Package : ${metadata.width.value.toFixed(2)} ${metadata.width.unit}
    4. Height of Last Package : ${metadata.height.value.toFixed(2)} ${metadata.height.unit}
    5. Tracking Id of Last Package :  ${metadata.trackingId}
    6. Event Time for last Package : ${new Date(metadata.eventTime)}`
    } else {
        return defaultMessage(reportName)
    }
}

export const getReport = (reportName, processPathAction, metadata, uniqueCharSeq) => {
    if (isScanDatAvailable(metadata)) {

        return (
            `${uniqueCharSeq}${reportName} Report ${uniqueCharSeq}
    1. Number of packages ${processPathAction} : ${metadata.count}
    2. Weight of the heaviest package ${processPathAction} : ${metadata.maxWt.toFixed(2)} kg ( ${(metadata.maxWt * pounds).toFixed(2)} lb)
    3. Average weight of the packages ${processPathAction} : ${metadata.avgWt.toFixed(2)} kg ( ${(metadata.avgWt * pounds).toFixed(2)} lb)
    4. Total weight of the packages ${processPathAction} : ${metadata.totalWt.toFixed(2)} kg ( ${(metadata.totalWt * pounds).toFixed(2)} lb)
    5. Total no of Heavy Packages ${processPathAction} > (${HEAVY_PACKAGE} lb): ${metadata.heavyCount}  `
        )
    } else {
        return defaultMessage(reportName)
    }
}


export const getOVReport = (reportName, processPathAction, metadata, uniqueCharSeq) => {
    if (isScanDatAvailable(metadata)) {
        console.log(metadata)
        return (
            `${uniqueCharSeq}${reportName} Report ${uniqueCharSeq}
    1. Number of OV Packages  ${processPathAction} : ${metadata.count}
    2. Weight of the heaviest OV Package ${processPathAction} : ${metadata.maxWt.toFixed(2)} kg ( ${(metadata.maxWt * pounds).toFixed(2)} lb)
    3. Average weight of the OV Packages ${processPathAction} : ${metadata.avgWt.toFixed(2)} kg ( ${(metadata.avgWt * pounds).toFixed(2)} lb)
    4. Total weight of the OV Packages ${processPathAction} : ${metadata.totalWt.toFixed(2)} kg ( ${(metadata.totalWt * pounds).toFixed(2)} lb)
    5. Number of Non Conveyable Packages ${processPathAction} : ${metadata.nonConveyableCount}
    6. Weight of the heaviest Non Conveyable Package ${processPathAction} : ${metadata.heaviestNonConveyable.toFixed(2)} kg ( ${(metadata.heaviestNonConveyable * pounds).toFixed(2)} lb)
    7. Total weight of the Non Conveyable Packages ${processPathAction} : ${metadata.totalNonConveyableWeight.toFixed(2)} kg ( ${(metadata.totalNonConveyableWeight * pounds).toFixed(2)} lb)
    8. Total no of Heavy Packages ${processPathAction} > (${HEAVY_PACKAGE} lb): ${metadata.heavyCount}  
    9. Highest Dimesnsion of package ${processPathAction} : ${metadata.heighestDimension} cm, Weight( ${metadata.heighestDimesnsionPackageWeight.toFixed(2)} kg ) (${(metadata.heighestDimesnsionPackageWeight * pounds).toFixed(2)} lb)
    
    `
        )
    } else {
        return defaultMessage(reportName)
    }
}

export const getBagReport = (reportName, processPathAction, metadata, tierData, uniqueCharSeq) => {
    if (isScanDatAvailable(metadata)) {
        return (
            `${uniqueCharSeq}${reportName} Report ${uniqueCharSeq}
    1. Number of bags  ${processPathAction} : ${metadata.count}
    2. Weight of the heaviest bag ${processPathAction} : ${metadata.maxWt.toFixed(2)} kg ( ${(metadata.maxWt * pounds).toFixed(2)} lb)
    3. Average weight of the bag ${processPathAction} : ${metadata.avgWt.toFixed(2)} kg ( ${(metadata.avgWt * pounds).toFixed(2)} lb)
    4. Total weight of the bag ${processPathAction} : ${metadata.totalWt.toFixed(2)} kg ( ${(metadata.totalWt * pounds).toFixed(2)} lb)
    5. Number of bag(s) ${processPathAction} from Tier 4 : ${tierData[3].result.bagCount}
    6. Maximum weight of bag(s) ${processPathAction} from Tier 4 : ${tierData[3].result.maxBagWt.toFixed(2)} kg ( ${(tierData[2].result.maxBagWt * pounds).toFixed(2)} lb)    
    7. Total weight of bag(s) ${processPathAction} from Tier 4 : ${tierData[3].result.totalWt.toFixed(2)} kg ( ${(tierData[2].result.totalWt.toFixed(2) * pounds).toFixed(2)} lb )
    8. Number of bag(s) ${processPathAction} from Tier 3 : ${tierData[2].result.bagCount}
    9. Maximum weight of bag(s) ${processPathAction} from Tier 3 : ${tierData[2].result.maxBagWt.toFixed(2)} kg ( ${(tierData[2].result.maxBagWt * pounds).toFixed(2)} lb)    
    10. Total weight of bag(s) ${processPathAction} from Tier 3 : ${tierData[2].result.totalWt.toFixed(2)} kg ( ${(tierData[2].result.totalWt.toFixed(2) * pounds).toFixed(2)} lb)
    11. Number of bag(s) ${processPathAction} from Tier 2 : ${tierData[1].result.bagCount}
    12. Maximum weight of bag(s) ${processPathAction} from Tier 2 : ${tierData[1].result.maxBagWt.toFixed(2)} kg ( ${(tierData[1].result.maxBagWt * pounds).toFixed(2)} lb)    
    13.Total weight of bag(s) ${processPathAction} from Tier 2 : ${tierData[1].result.totalWt.toFixed(2)} kg ( ${(tierData[1].result.totalWt.toFixed(2) * pounds).toFixed(2)} lb)
    14. Number of bag(s) ${processPathAction} from Tier 1 : ${tierData[0].result.bagCount}
    15. Maximum weight of bag(s) ${processPathAction} from Tier 1 : ${tierData[0].result.maxBagWt.toFixed(2)} kg ( ${(tierData[0].result.maxBagWt * pounds).toFixed(2)} lb)    
    16. Total weight of bag(s) ${processPathAction} from Tier 1 : ${tierData[0].result.totalWt.toFixed(2)} kg ( ${(tierData[0].result.totalWt.toFixed(2) * pounds).toFixed(2)} lb)
    17. Total Number of heavy bag(s) ${processPathAction} > (${HEAVY_BAG} lb) : ${metadata.heavyCount}`
        )
    } else {
        return defaultMessage(reportName)
    }
}

export const getCartReport = (reportName, processPathAction, metadata, uniqueCharSeq) => {
    if (isScanDatAvailable(metadata)) {
        return (
            `${uniqueCharSeq}${reportName} Report ${uniqueCharSeq}
    1. Number of cart(s)  ${processPathAction} : ${metadata.count}
    2. Weight of the heaviest cart ${processPathAction} : ${metadata.maxWt.toFixed(2)} kg(${(metadata.maxWt * pounds).toFixed(2)} lb)
    3. Average weight of the cart ${processPathAction} : ${metadata.avgWt.toFixed(2)} kg(${(metadata.avgWt * pounds).toFixed(2)} lb)
    4. Total weight of the cart(s) ${processPathAction} : ${metadata.totalWt.toFixed(2)} kg(${(metadata.totalWt * pounds).toFixed(2)} lb)
    5. Total Number of heavy cart(s) ${processPathAction} > (${HEAVY_CART} lb) : ${metadata.heavyCount}`
        )
    }
    else {
        return defaultMessage(reportName)
    }
}


const isScanDatAvailable = (metadata) => {
    return (metadata == null || metadata.count === 0 || metadata.maxWt === 0 || metadata.avgWt === 0 || metadata.totalWt === 0) ? false : true;
}

const defaultMessage = (reportName) => {
    return (
        `$$$###${reportName} Report###$$$
    Scan information is not available for ${reportName} during selected time`
    )
}



// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/ReportFormatUtil.js